import TableInterface from "@homegame/common/dist/interface/table.interface";
import UserService from "../core/service/user.service";
import { useEffect, useState } from "react";
import { useAuth } from "../core/context/auth.context";
import GamePlayerInterface from "@homegame/common/dist/interface/game-player.interface";
import GameStatus from "@homegame/common/dist/enum/game-status.enum";
import TablePlayerStatus from "@homegame/common/dist/enum/table-player-status.enum";
import Chip from "@mui/material/Chip";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import HourglassFullIcon from "@mui/icons-material/HourglassFull";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import GamePlayerStatus from "@homegame/common/dist/enum/game-player-status.enum";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";

const useStyles = makeStyles(() =>
  createStyles({
    chip: {
      marginTop: 5,
      fontSize: 11,
      fontWeight: 300,
      height: 18,
      borderRadius: 5,
      clear: "both",
      maxWidth: "fit-content",
      "& .MuiChip-icon": {
        color: "#fff",
        fontSize: 11,
        marginTop: -1,
      },
    },
  }),
);

export default function TableStatusComponent({
  table,
}: {
  table: TableInterface;
}) {
  const classes = useStyles();
  const userService = new UserService();
  const { user } = useAuth();

  const [gameInvites, setGameInvites] = useState<GamePlayerInterface[]>([]);

  useEffect(() => {
    if (user && user.id)
      userService.getGameInvites(user.id).then((d) => setGameInvites(d.data));
  }, []);

  if (!table || !table.games) return;

  const hasOngoingGame = table.games.some(
    (game: any) => game.status === GameStatus.ONGOING,
  );

  const hasPendingTableInvite = table.players
    ? table.players.some(
        (player: any) =>
          player.status === TablePlayerStatus.PENDING &&
          player.playerId === user!.id,
      )
    : false;

  const tableGameIds = table.games.map((game: any) => game.id);

  const invites =
    gameInvites?.filter((gameInvite) =>
      tableGameIds.includes(gameInvite.gameId),
    ) || [];

  if (hasOngoingGame)
    return (
      <Chip
        className={classes.chip}
        color="success"
        label="Ongoing game"
        icon={<AutorenewIcon />}
      />
    );

  if (hasPendingTableInvite)
    return (
      <Chip
        className={classes.chip}
        color="info"
        label="New invite"
        icon={<HourglassFullIcon />}
      />
    );

  if (invites.length > 0) {
    return invites.map((invite) => {
      let color = "info";
      let icon = <HourglassFullIcon />;
      let label = "New invite";
      if (invite.status === GamePlayerStatus.REGISTERED) {
        color = "success";
        label = "Registered";
        icon = <DoneIcon />;
      }
      if (invite.status === GamePlayerStatus.UNREGISTERED) {
        color = "error";
        label = "Declined";
        icon = <ClearIcon />;
      }
      return (
        <Chip
          className={classes.chip}
          // @ts-ignore
          color={color}
          label={label}
          icon={icon}
        />
      );
    });
  }
}
